import Box, { BoxProps } from '@mui/material/Box';

function ContainerNarrow(props: BoxProps) {
  return <Box maxWidth="800px" width="100%" padding="10px 20px" {...props} />;
}

export default ContainerNarrow;
